import activityContext from './use-recent-activity';
import { ComponentLoader } from 'views/Member/components/ComponentLoader';

export const ActivityLoading = () => {
  const { showLoading } = activityContext.useController();

  return !showLoading ? null : <ComponentLoader isLoading={showLoading} />;
};
